<template>
  <div>
    <v-select
      v-model="newValue"
      :items="positions"
      label="Positions"
      item-text="label"
      item-value="value"
      color="blue"
      item-color="info"
      menu-props="light"
      clearable
      :rules="[v => (!!v && v.length > 0) || 'Required']"
      hide-details
    >
    </v-select>
  </div>
</template>
<script>
export default {
  props: ["value", "merchType"],
  name: "MenuPositionByType",
  data: function() {
    return {
      newValue: this.value
    };
  },
  computed: {
    positions() {
      let positions = this.$store.getters.getReference("menu_positions_"+this.$props.merchType ) || [];
      let transformed = [];
      Object.entries(positions).forEach(([value, label]) => {
        transformed.push({
          value: value,
          label: label
        });
      });

      return transformed;
    }
  },
  watch: {
    newValue: {
      handler: function(val) {
        this.$emit("input", !!val ? val : null);
      },
      deep: true
    }
  }
};
</script>
